import { Logger } from '@instinet-analytics/core-lib';
/*
 * Buffer that waits for OUT_RATE ms before emitting messages
 */
export default class Buffer<T> {
    private interval = 1000;
    private outTimeoutId: NodeJS.Timeout | undefined;
    private out: (data: T[]) => void;
    private logger: Logger | undefined;
    private pending: T[];

    public constructor(out: (data: T[]) => void, logger?: Logger) {
        this.out = out;
        this.logger = logger;
        this.outTimeoutId = undefined;
        this.pending = [];
    }

    public in(data: T[] | undefined) {
        if (!data) {
            return;
        }
        this.pending = this.pending.concat(data);
        this.scheduleOut();
    }

    public reset() {
        if (this.pending.length > 0) {
            this.logger?.info(
                `Reset discarding ${this.pending.length} messages`,
                { first: this.pending[0], last: [this.pending.length - 1] }
            );
        }
        this.pending = [];
        this.clearTimer();
    }

    public setInterval(interval: number) {
        this.interval = interval;
    }

    public flush() {
        this.out(this.pending);
        this.pending = [];
        this.clearTimer();
    }

    private scheduleOut() {
        this.outTimeoutId =
            this.outTimeoutId || setTimeout(() => this.flush(), this.interval);
    }

    private clearTimer() {
        if (this.outTimeoutId) {
            clearTimeout(this.outTimeoutId);
        }
        this.outTimeoutId = undefined;
    }
}
